export enum DetailsPanelTabType {
    DATA = 'data',
    DATA_LABEL = 'Data',
    ATTACHMENTS = 'attachments',
    ATTACHMENTS_LABEL = 'Attachments',
    COMMENTS = 'comments',
    COMMENTS_LABEL = 'Comments',
}